import * as React from 'react';
import styled, { css } from 'styled-components';

const CHECKERED_BACKGROUND_SIZE = 2;

const ThumbnailContainer = styled.div`
  position: relative;
  display: inline-block;
  min-height: 0;
  width: 100%;
  padding-top: ${({ assetRatio }) => {
    if (parseInt(assetRatio) < 100) {
      return assetRatio;
    } else {
      return '56.25%';
    }
  }};
  background: ${({ theme }) => theme.colors.interactiveBg.disable};
  border-radius: ${({ theme }) => theme.borders.radius.small};
  overflow: hidden;

  ${({ hasTransparency }) =>
    hasTransparency &&
    css`
      background-color: #303436;
      background-image: linear-gradient(45deg, #515557 25%, transparent 25%),
        linear-gradient(135deg, #515557 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #515557 75%),
        linear-gradient(135deg, transparent 75%, #515557 75%);
      background-size: ${CHECKERED_BACKGROUND_SIZE}px
        ${CHECKERED_BACKGROUND_SIZE}px;
      background-position: 0 0, ${CHECKERED_BACKGROUND_SIZE / 2}px 0,
        ${CHECKERED_BACKGROUND_SIZE / 2}px -${CHECKERED_BACKGROUND_SIZE / 2}px,
        0px ${CHECKERED_BACKGROUND_SIZE / 2}px;
    `}

  img,
  video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ assetRatio }) => {
      if (parseInt(assetRatio) >= 100) {
        return 'height: 100%; width: auto;';
      } else {
        return 'width: 100%; height: auto;';
      }
    }};
  }
`;

function ExternalMediaThumbnail({
  assetRatio,
  children,
  hasTransparency = false,
}: {
  assetRatio: string;
  children: React.ReactNode;
  hasTransparency?: boolean;
}) {
  return (
    <ThumbnailContainer
      assetRatio={assetRatio}
      hasTransparency={hasTransparency}
    >
      {children}
    </ThumbnailContainer>
  );
}

export default ExternalMediaThumbnail;
